import React from "react"
import { Link } from "react-router"

export default function NotFound() {
  return (
    <article>
      <h1>Page not found.</h1>
      <Link to="/" className="btn">
        Home
      </Link>
    </article>
  )
}



// WEBPACK FOOTER //
// ./src/components/NotFound/index.js